<template>
    <div>
        <div>akri-works-list-component</div>
        <dx-select-box
            v-model="state.monthId"
            :data-source="months"
            value-expr="id"
            display-expr="name"
            @valueChanged="monthChanged($event)"
        />
    </div>
</template>

<script>
export default {
    name: 'akri-works-list-component'
};
</script>

<script setup>
import { ref, defineEmits, onMounted, defineProps} from 'vue';
import { DxSelectBox } from 'devextreme-vue';

import { monthsList } from '@/views/arki/services/arki-service';

const state = ref({ monthId: null });
const months = ref([]);

const emit = defineEmits([
    'monthChanged',
]);

const { defaultMonthId } = defineProps({
    defaultMonthId: Number
})

onMounted(() => {
    state.value.monthId = defaultMonthId;
    months.value = monthsList;
});

const monthChanged = () => {
    emit('monthChanged', state.value);
}

</script>

<style scoped>

</style>
